module.exports = __webpack_public_path__ + "img/avatar.94a956d6.png";